import React, { useEffect } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import ClientCheck from '../models/clientcheck';
import TsdiClient from 'src/models/AP/Client';

interface IAddClientDepositCheckDialogProps {
    client: TsdiClient;
    dialogName: string;
    existingCheck?: ClientCheck;
    nextCheckNumber?: number;
    handleAddCheck: (check: ClientCheck) => void;
    hideDialog: () => void;
}

const toDateInputValue = (value: Date | string) => {
    if (!value) {
        return new Date().toISOString().split('T')[0];
    }
    return new Date(value).toISOString().split('T')[0];
};

const AddClientDepositCheckDialog = (props: IAddClientDepositCheckDialogProps) => {
    const { register, errors, getValues } = useForm();

    useEffect(() => {
        onCreate();
    }, []);

    useEffect(() => {
        onCreate();
    }, [props.dialogName]);

    const onCreate = () => {
        console.log('AddClientDepositCheckDialog onCreate()');
    };

    const OKClicked = () => {
        props.handleAddCheck(getValues() as ClientCheck);
    };

    return (
        <Dialog title={props.existingCheck ? 'Update Check' : 'Add Client Deposit Check'} dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '10%' }}>
            <form key={props.existingCheck ? `edit-${props.existingCheck.number}` : `add-${props.nextCheckNumber}`}>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'left', flexDirection: 'column' }}>
                <label>{props?.client?.clientNumber} - {props?.client?.clientName}</label>
                <RHFInputBox
                    label="Issue Date"
                    labelStyle={{width: '9rem', display: 'inline-block', whiteSpace: 'nowrap'}}
                    labelOnLeft={true}
                    name={`issueDate`}
                    type="date"
                    defaultVal={toDateInputValue(props.existingCheck?.issueDate)}
                    register={register}
                    errors={errors}
                    style={{ width: '100%' }}
                    bodyStyle={{ width: '100%' }}
                />
                <RHFInputBox
                    label="Check #"
                    labelStyle={{width: '9rem', display: 'inline-block', whiteSpace: 'nowrap'}}
                    labelOnLeft={true}
                    name={`number`}
                    type="text"
                    readOnly={true}
                    defaultVal={props.existingCheck ? props.existingCheck.number.toString() : props.nextCheckNumber?.toString()}
                    register={register}
                    errors={errors}
                    style={{ width: '100%' }}
                    bodyStyle={{ width: '100%' }}
                />
                <RHFInputBox
                    label="Amount"
                    labelStyle={{width: '9rem', display: 'inline-block', whiteSpace: 'nowrap'}}
                    labelOnLeft={true}
                    name={`amount`}
                    type="text"
                    defaultVal={props.existingCheck ? props.existingCheck.amount.toString() : undefined}
                    register={register}
                    errors={errors}
                    style={{ width: '100%' }}
                    bodyStyle={{ width: '100%' }}
                />
                <RHFInputBox
                    label="Received Date"
                    labelStyle={{width: '9rem', display: 'inline-block', whiteSpace: 'nowrap'}}
                    labelOnLeft={true}
                    name={`receivedDate`}
                    type="date"
                    defaultVal={toDateInputValue(props.existingCheck?.receivedDate)}
                    register={register}
                    errors={errors}
                    style={{ width: '100%' }}
                    bodyStyle={{ width: '100%' }}
                />
            </div>
            <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'OK'}
                    onClick={() => OKClicked()}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Cancel'}
                    onClick={() => props.hideDialog()}
                />
            </div>
            </form>
        </Dialog>
    );
};

export default AddClientDepositCheckDialog;



// WEBPACK FOOTER //
// ./src/components/accounts-receivable/dialogs/AddClientDepositCheckDialog.tsx